import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M925.966182,1226.25955 C944.762449,1253.5558 975.234883,1253.55919 994.033486,1226.25955 L1345.1073,716.424242 C1363.90357,689.127987 1352.28747,667 1319.14817,667 L600.851498,667 C567.718398,667 556.093763,689.124596 574.892365,716.424242 L925.966182,1226.25955 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1",
  transform: "matrix(-1 0 0 1 1920 0)"
});

var IconMiniArrowDownLine = /*#__PURE__*/function (_Component) {
  _inherits(IconMiniArrowDownLine, _Component);

  var _super = _createSuper(IconMiniArrowDownLine);

  function IconMiniArrowDownLine() {
    _classCallCheck(this, IconMiniArrowDownLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconMiniArrowDownLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMiniArrowDown",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMiniArrowDownLine.displayName = "IconMiniArrowDownLine";
  return IconMiniArrowDownLine;
}(Component);

IconMiniArrowDownLine.glyphName = 'mini-arrow-down';
IconMiniArrowDownLine.variant = 'Line';
IconMiniArrowDownLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMiniArrowDownLine;
export { IconMiniArrowDownLine };